type CompletePageProps = { visible: boolean };

export default function CompletePage({ visible }: CompletePageProps) {
  return (
    <div
      className="md:px-2"
      style={{
        visibility: visible ? "visible" : "hidden",
        height: visible ? "auto" : 0,
        position: visible ? "static" : "absolute",
        top: visible ? "auto" : 0,
      }}
    >
      <h2 className="text-md lg:text-xl font-semibold">Thank You</h2>
      <p>Your application is being processed.</p>
    </div>
  );
}
